import { useMutation, useQueryClient } from '@tanstack/react-query';
import { billingService, queryKeys } from '@/services';
import type { GenerateStatementParams } from '@/services/billing/billing-service';

/**
 * Manual statement generation (LR-510). On success, invalidate the whole
 * billing-statements branch so the list refetches and shows the new statement(s).
 */
export const useGenerateStatement = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: GenerateStatementParams) =>
      billingService.generateStatement(params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.billing.statements() });
    },
  });
};
